const gql = require('graphql-tag');

const COMPANY_CONTACT_DETAIL_QUERY = gql`
    query companyContactForGuest($listingId: String!) {
        companyContactForGuest(listingId: $listingId) {
            companyLabel
            companyName
            companyAddressLabels
        }
    }
`;

export default COMPANY_CONTACT_DETAIL_QUERY;
